var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-30" },
    [
      _c(
        "md-card",
        { staticClass: "mt-20" },
        [
          _c("md-card-header", {
            staticClass: "ask-subject",
            style: _vm.communityStyle,
            domProps: {
              textContent: _vm._s(
                _vm.$lodash.has(_vm.community, "name")
                  ? _vm.community.name + ": " + _vm.ask.subject
                  : _vm.ask.subject
              )
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ask-detail",
        {
          staticClass: "mt-30",
          attrs: { ask: _vm.ask, editAsk: "true" },
          on: { chosen: _vm.addSeeker }
        },
        [_vm._v("Ask detail goes here...")]
      ),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-30" },
        [
          _c("md-card-header", [
            _c("div", { staticClass: "md-title card-header" }, [
              _vm._v("What insight did this advisor give:")
            ])
          ]),
          _vm._v(" "),
          _c(
            "md-card-content",
            [
              _c(
                "md-field",
                { staticClass: "textareaAfter" },
                [
                  _c("md-textarea", {
                    attrs: { placeholder: "..." },
                    on: {
                      input: function($event) {
                        _vm.insight = _vm.sanitizeInput($event)
                      }
                    },
                    model: {
                      value: _vm.insight,
                      callback: function($$v) {
                        _vm.insight = $$v
                      },
                      expression: "insight"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-card",
                [
                  _c("md-card-header", [
                    _vm._v("\n\t\t\t\t\tWho gave this insight?\n\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-card-content",
                    [
                      _vm.advisors.length > 0
                        ? _c(
                            "multi-member-picker",
                            {
                              attrs: {
                                members: _vm.advisors,
                                selected: _vm.selectedAdvisors
                              },
                              on: { changed: _vm.updateSelected }
                            },
                            [_vm._v("Advisors goes here...")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _vm._v(" "),
              _c(
                "md-ripple",
                [
                  _c(
                    "base-interaction-button",
                    {
                      attrs: { interaction: _vm.action },
                      on: { interact: _vm.doInteraction }
                    },
                    [_vm._v(_vm._s(_vm.action))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("ask-feedback", { staticClass: "mt-30", attrs: { ask: _vm.ask } }, [
        _vm._v("Feedback goes here...")
      ]),
      _vm._v(" "),
      _c(
        "comments",
        { staticClass: "mt-30", attrs: { ask: _vm.ask, section: "Comments" } },
        [_vm._v("Activity log goes here...")]
      ),
      _vm._v(" "),
      _c("activity-log", { staticClass: "mt-30", attrs: { ask: _vm.ask } }, [
        _vm._v("Activity log goes here...")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c2ca43c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c2ca43c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InteractAddGive.vue
// module id = null
// module chunks = 